/** Created by azhou on 2018/7/24.*/
<template>
  <div class="mt-1 d-flex align-items-start mb-3">
    <ul class="w-25">
      <li :class="{active:activeAnch==='0'}" @click="activeAnch='0'">服务条款</li>
      <li :class="{active:activeAnch==='1'}" @click="activeAnch='1'">隐私条款</li>
      <li :class="{active:activeAnch==='2'}" @click="activeAnch='2'">免责说明</li>
    </ul>
    <div class="w-75 pl-4 pb-5 pt-2 pr-4">
      <service-doc v-if="activeAnch==='0'" />
      <privacy-doc v-if="activeAnch==='1'" />
      <duty-doc v-if="activeAnch==='2'" />
    </div>
  </div>
</template>

<script>
  import ServiceDoc from './ServiceDoc.vue'
  import PrivacyDoc from './PrivacyDoc.vue'
  import DutyDoc from './DutyDoc.vue'

  export default {
    data () {
      return {
        activeAnch: this.$route.query.anch
      }
    },
    components: { ServiceDoc, PrivacyDoc, DutyDoc }
  }
</script>
<style lang="scss" scoped>
  @import '@/assets/css/color.scss';
  .active {
    background: $loginBlue;
    color: #fff;
    box-shadow: 0 5px 5px #aaa;
    margin-bottom: 8px;
  }
  li {
    background: rgba(244, 244, 244, 1);
    color: #818181;
    cursor: pointer;
    padding: 10px 0;
    &:hover {
      background:$loginBlue;
      color: #fff;
      margin-bottom: 8px;
      box-shadow: 0 5px 5px #aaa;
    }
  }
</style>
